// extracted by mini-css-extract-plugin
module.exports = {"header_link":"_1eZQW","banner":"_1JZ4t","center":"_3GOHO"};